import { Bar, BarChart, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { axisShort, money } from "@/lib/format";

export const GapChart = ({ rows, currency, height = 220, fixedWidth }) => {
  const data = rows.map((r) => ({ name: r.label, Need: Math.round(r.need), Available: Math.round(Math.min(r.available, r.need)), Gap: Math.round(r.gap) }));
  const chart = (
    <BarChart data={data} width={fixedWidth} height={height} margin={{ top: 8, right: 8, left: 0, bottom: 0 }}>
      <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#E2E8F0" />
      <XAxis dataKey="name" tick={{ fontSize: 11, fill: "#64748B" }} axisLine={false} tickLine={false} />
      <YAxis tickFormatter={(v) => axisShort(v, currency)} tick={{ fontSize: 10, fill: "#94A3B8" }} axisLine={false} tickLine={false} width={64} />
      <Tooltip formatter={(v) => money(v, currency)} cursor={{ fill: "#F1F5F9" }} />
      <Legend wrapperStyle={{ fontSize: 11 }} iconType="circle" />
      <Bar dataKey="Available" stackId="a" fill="#10B981" isAnimationActive={!fixedWidth} />
      <Bar dataKey="Gap" stackId="a" fill="#E11D48" radius={[4, 4, 0, 0]} isAnimationActive={!fixedWidth} />
    </BarChart>
  );
  return (
    <div data-testid="gap-chart" style={{ height }}>
      {fixedWidth ? chart : <ResponsiveContainer width="100%" height="100%">{chart}</ResponsiveContainer>}
    </div>
  );
};
